export const apiCallStateConfig = [];
